export const apiCallStateConfig = [];
